
import { HttpResponse } from "../auth/AuthInterface";

import { RolProps } from "./RolInterface";
import { TiposTurnoProps } from "./TiposTurnoInterface";
import { TurnoProps } from "./TurnoInterface";
import { UnidadProps } from "./UnidadInterface";
import { UbicacionProps } from "./UbicacionInterface";

// Definición de defaults

export const defaultConfiguracion: ConsultarConfiguracionData = {
    ubicacion: {
        id: 0,
        nombre: '',
        numero: 0,
    },
    usuario_nombre_completo: '',
    turnos_tipos: [],
    unidad: {
        id: 0,
        nombre: '',
        clave: '',                            
    },
    rol: {
        id: 0, 
        nombre: '',                            
    }                         
}

// Creación de interfaces

export interface ConsultarConfiguracionParams {
    usuario_id:  number;
}

export interface ConsultarConfiguracionResponse extends HttpResponse {
    data:  ConsultarConfiguracionData;
}

export interface ActualizarConfiguracionParams {
    usuario_id:               number;
    ubicacion_id:             number;
    turnos_tipos_ids:         number[];
}

export interface ActualizarConfiguracionResponse extends HttpResponse {
   data:  ConsultarConfiguracionData;
}

export interface ConsultarConfiguracionData {
    ubicacion:                  UbicacionProps;
    unidad:                     UnidadProps;
    rol:                        RolProps;
    turnos_tipos?:              TiposTurnoProps[];
    usuario_nombre_completo:    string;
    ultimo_turno?:              TurnoProps;
}